import { useEffect, Fragment, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Grid, Typography, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";


function PCNDetails() {
    const { id } = useParams();
    const [pcn, setPcn] = useState([]);
    const [mfr, setMfr] = useState("");
    const [downloadLink, setDownloadLink] = useState("");
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [parts, setParts] = useState([]);
    const [password, setPassword] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        const getPCN = async () => {
            setLoading(true);
            const requestOptions = {
                headers: { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_APIM_KEY }
            };
    
            var requestUrl = `${process.env.REACT_APP_APIM_URL}/pcn-affected-parts?pcn=${id}&bc=${process.env.REACT_APP_SBOAT}`;
    
            await axios
                .get(requestUrl, requestOptions)
                .then((resp) => {
                    let data = resp.data.data;
                    setPcn(data.pcn);
                    setDownloadLink(data.download_link);
                    setParts(data.parts);
                    setMfr(data.pcn.MFR_ID);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        };
        getPCN();
    }, [id]);

    const Item = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
    }));

    const returnToPreviousPage = () => {
        navigate("/");
        //navigate(process.env.PUBLIC_URL);
    };

    const downloadPDFOrPasswordPrompt = () => {
        if (typeof switchPassword(mfr) === "undefined") {
            window.location.href = downloadLink;
            return;
        }
        setOpen(true);
    };
    const justDownloadPDF = () => {
        window.location.href = downloadLink;
        setOpen(false);
    };
    const handleClickOpen = () => {
        downloadPDFOrPasswordPrompt();
    };
    const handleClose = () => {
        setOpen(false);
        setShowMessage(false);
    };
    const comparePassword = () => {
        password !== switchPassword(mfr)
            ? setShowMessage(true)
            : justDownloadPDF();
    };
    const switchPassword = (mfr) =>
    ({
        LTQ: "pcn_lantiq",
        SAM: "pcn_samsung",
        OOS: "pcn_osram",
        PHS: "pcn_nxp",
    }[mfr]);

    return (
        <Fragment>
            <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="space-between"
                sx={{
                    border: "1px solid #ccc",
                    background: "#fafafa",
                    borderRadius: 0,
                    mt: 2,
                }}
            >
                <Grid item xs={10}>
                    {!loading ? (
                        <Fragment>
                            <Typography variant="button" display="block" noWrap sx={{ textDecoration: "underline" }}>
                                {pcn.MFR_NAME}
                            </Typography>
                            <Typography variant="h6" display="block" noWrap sx={{ mb: 1 }}>{pcn.PCN_ID}</Typography>
                            <Typography variant="h5" display="block" noWrap sx={{ mb: 3 }}>{pcn.PCN_MFR_ID}</Typography>
                            <Typography
                                variant="button"
                                display="block"
                                gutterBottom
                            >
                                {pcn.PCN_SUBJECT}
                            </Typography>
                        </Fragment>
                    ) : (
                        <CircularProgress
                            color="primary"
                            sx={{ mt: 2, ml: 5 }}
                        />
                    )}
                </Grid>
                <Grid item xs={2}>
                    {!downloadLink ? "" : (
                        <Button
                            variant="contained"
                            onClick={handleClickOpen}
                            sx={{ mb: 1, mt: 0 }}
                            color="warning"
                        >
                            Download
                        </Button>)}
                    <Dialog open={open} onClose={handleClose}>
                        <DialogTitle>Security check</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                To access this PDF file you need to enter
                                password
                            </DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="password"
                                label="Password"
                                type="password"
                                fullWidth
                                onChange={(e) => setPassword(e.target.value)}
                                variant="standard"
                            />
                            <span
                                style={{
                                    color: "red",
                                    display: !showMessage ? "none" : "block",
                                }}
                            >
                                Password is incorrect
                            </span>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button onClick={comparePassword}>Submit</Button>
                        </DialogActions>
                    </Dialog>
                    <Button
                        variant="contained"
                        onClick={(e) => returnToPreviousPage()}
                        startIcon={<SearchIcon />}
                        sx={{ mb: 2, mt: 0 }}
                        color="warning"
                        title="Back to Search"
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>
            <Grid>
                {!loading ? (
                    <Typography
                        variant="button"
                        display="block"
                        gutterBottom
                        noWrap
                        sx={{ mt: 3, mb: 3 }}
                    >
                        Affected Materials:
                    </Typography>
                ) : (
                    <CircularProgress
                        color="primary"
                        sx={{ mt: 2, ml: 5 }}
                    />
                )}
            </Grid>
            <Grid container spacing={2} columns={16} sx={{ pr: 4, mt: 1 }}>
                {parts.length > 0 &&
                    parts.map((part) => {
                        return (
                            <Grid item xs={4} key={part.AFF_PART}>
                                <Item sx={{ fontWeight: 'medium' }}>{part.AFF_PART}</Item>
                            </Grid>
                        );
                    })}
            </Grid>
        </Fragment>
    );
}

export default PCNDetails;
